import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Autocomplete,
  createFilterOptions,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import moment from "moment";
import NumberFormat from "react-number-format";

import { v4 as uuidv4 } from "uuid";

import CloseIcon from "@mui/icons-material/Close";
import "./style.css";
import { Model } from "../../../models/model";
import { parseToNum } from "../../../helpers/pptosGastos";
import { iniUpdateBudget } from "../../../redux/actions/pptos";

const filter = createFilterOptions();

export const DialogAddProjectionsByItems = ({ open, setOpen, params }) => {
  const dispatch = useDispatch();

  const { itemsSelected, type } = params;

  const { listaTiposDocumentos } = useSelector((state) => state.general);
  const { listSuppliers } = useSelector((state) => state.contacts);
  const {
    id: pptoId,
    simbolo,
    separacion_decimales,
    separacion_miles,
  } = useSelector((state) => state.ppto.detail);
  const [projections, setProjections] = useState([]);
  // console.log({ projections })

  const detailBudget = useSelector((state) => state.ppto.detail);
  const [tasksList, setTasksList] = useState([]);

  const handleGetTasks = useCallback(async () => {
    const filters = {
      id_ppto: pptoId,
      view: "list",
      id_responsable: 0,
      estado: "",
      programacion: "",
    };

    const params = new URLSearchParams(filters).toString();
    const newTasksList = await Model.getAll({ url: `tasks/?${params}` });
    setTasksList(newTasksList);
  }, [pptoId]);

  const loadInitialValues = useCallback(() => {
    let newList = [];
    for (let x = 0; x < itemsSelected.length; x++) {
      const item = itemsSelected[x];

      if (type === "ingreso") {
        //if (parseFloat(item.precio_subtotal) > 0) {
        const SaldoPorProyectar =
          item?.total_proyectado > 0
            ? item?.saldo_por_proyectar
            : item?.saldo_por_proyectar || item.precio_subtotal;

        //if (SaldoPorProyectar > 0) {
        newList = [
          ...newList,
          {
            id: uuidv4(),
            referencia: item.nombre,
            porcentaje_flow: 100,
            saldo_por_proyectar: SaldoPorProyectar,
            monto_neto: SaldoPorProyectar,
            id_item_ppto: item.id,
            total_item_ppto: item.precio_subtotal,
            fecha_proyeccion: moment(new Date()).format("YYYY-MM-DD"),
            id_tarea: null,
            tipo_flujo: "ingreso",
            id_doc: 1,
            porcentaje_impuesto: 18,
            impuesto_tipo_calculo: "directo",
            total: parseFloat(SaldoPorProyectar) * 1.18,
            id_contacto: null,
            saved: false,
          },
        ];
        //}

        // }
      }

      if (type === "egreso") {
        //if (parseFloat(item.costo_subtotal) > 0) {
        const SaldoPorProyectar =
          item?.total_proyectado_egresos > 0
            ? item?.saldo_por_proyectar_egresos
            : item?.saldo_por_proyectar_egresos || item.costo_subtotal;

        //if (SaldoPorProyectar > 0) {
        newList = [
          ...newList,
          {
            id: uuidv4(),
            referencia: item.nombre,
            porcentaje_flow: 100,
            saldo_por_proyectar: SaldoPorProyectar,
            monto_neto: SaldoPorProyectar,
            id_item_ppto: item.id,
            total_item_ppto: item.costo_subtotal,
            fecha_proyeccion: moment(new Date()).format("YYYY-MM-DD"),
            id_tarea: null,
            tipo_flujo: "egreso",
            id_doc: 1, // factura 18%
            porcentaje_impuesto: 18,
            impuesto_tipo_calculo: "directo",
            total: parseFloat(SaldoPorProyectar) * 1.18,
            id_contacto: null,
            saved: false,
          },
        ];
        //}

        //}
      }
    }

    setProjections(newList);
  }, [itemsSelected, type]);

  const handleChangePercent = async (values, item) => {
    if (!values.sourceInfo.event) return false;

    const newList = projections.map((it) => {
      if (it.id === item.id) {
        const totalItem = parseFloat(item.saldo_por_proyectar);
        let newImpuesto = values.floatValue;
        let newMontoNeto = (newImpuesto / 100) * totalItem;

        if (newMontoNeto > totalItem) {
          newMontoNeto = totalItem;
          newImpuesto = 100;
        }

        const factorImpuesto = item.porcentaje_impuesto
          ? parseToNum(item.porcentaje_impuesto) / 100
          : 0;
        const totalImpuesto =
          parseToNum(newMontoNeto) * parseToNum(factorImpuesto);
        const newtotalImpuesto = parseToNum(totalImpuesto, 2, true);

        let newTotal = 0;
        if (item.impuesto_tipo_calculo === "retencion") {
          const totalAux =
            parseToNum(newMontoNeto) - parseToNum(newtotalImpuesto);
          newTotal = parseToNum(totalAux, 2, true);
        } else {
          const totalAux =
            parseToNum(newMontoNeto) + parseToNum(newtotalImpuesto);
          newTotal = parseToNum(totalAux, 2, true);
        }

        return {
          ...it,
          porcentaje_flow: newImpuesto,
          monto_neto: newMontoNeto,
          total: newTotal,
        };
      }

      return it;
    });

    setProjections(newList);
  };

  const handleChangeMonto = (values, item) => {
    if (!values.sourceInfo.event) return false;

    let { floatValue: newMontoNeto } = values;
    const newList = projections.map((it) => {
      if (it.id === item.id) {
        const totalItem = parseFloat(item.saldo_por_proyectar);
        let newImpuesto = (newMontoNeto / totalItem) * 100;

        // if (newMontoNeto > totalItem) {
        //     newMontoNeto = totalItem
        //     newImpuesto = 100
        // }

        const factorImpuesto = item.porcentaje_impuesto
          ? parseToNum(item.porcentaje_impuesto) / 100
          : 0;
        const totalImpuesto =
          parseToNum(newMontoNeto) * parseToNum(factorImpuesto);
        const newtotalImpuesto = parseToNum(totalImpuesto, 2, true);

        let newTotal = 0;
        if (item.impuesto_tipo_calculo === "retencion") {
          const totalAux =
            parseToNum(newMontoNeto) - parseToNum(newtotalImpuesto);
          newTotal = parseToNum(totalAux, 2, true);
        } else {
          const totalAux =
            parseToNum(newMontoNeto) + parseToNum(newtotalImpuesto);
          newTotal = parseToNum(totalAux, 2, true);
        }

        return {
          ...it,
          monto_neto: newMontoNeto,
          porcentaje_flow: newImpuesto,
          total: newTotal,
        };
      }

      return it;
    });

    setProjections(newList);
  };

  const handleChangeDate = (e, id) => {
    const { value } = e.target;

    const newList = projections.map((it) => {
      if (it.id === id) {
        return {
          ...it,
          fecha_proyeccion: value,
        };
      }

      return it;
    });

    setProjections(newList);
  };

  const handleChangeRef = (e, id) => {
    const { value } = e.target;

    const newList = projections.map((it) => {
      if (it.id === id) {
        return {
          ...it,
          referencia: value,
        };
      }

      return it;
    });

    setProjections(newList);
  };

  const handleChangeHito = (e, id) => {
    const { value } = e.target;
    const arrayInfo = value.split("|");
    // console.log({ arrayInfo })

    const idTarea = arrayInfo[0];
    const fechaTarea = arrayInfo[1];
    // console.log({ idTarea, fechaTarea })

    const newList = projections.map((it) => {
      if (it.id === id) {
        return {
          ...it,
          id_tarea: idTarea,
          fecha_proyeccion: fechaTarea,
        };
      }

      return it;
    });

    setProjections(newList);
  };

  const handleChangeDoc = (e, id) => {
    const { value: newIdDoc } = e.target;

    const newList = projections.map((it) => {
      if (it.id === id) {
        const foundImpuesto = listaTiposDocumentos?.find(
          (doc) => parseInt(doc.id) === parseInt(newIdDoc),
        );
        const porcentaje =
          foundImpuesto.impuestos[0]?.porcentaje_impuesto || 18;
        const newPorcentajeImpuesto = parseFloat(porcentaje);
        const impuesto_tipo_calculo =
          foundImpuesto.impuestos[0]?.tipo_calculo || "directo";

        const factorImpuesto = newPorcentajeImpuesto
          ? parseToNum(newPorcentajeImpuesto) / 100
          : 0;
        const totalImpuesto =
          parseToNum(it.monto_neto) * parseToNum(factorImpuesto);
        const newtotalImpuesto = parseToNum(totalImpuesto, 2, true);

        let newTotal = 0;
        if (impuesto_tipo_calculo === "retencion") {
          const totalAPagar =
            parseToNum(it.monto_neto) - parseToNum(newtotalImpuesto);
          newTotal = parseToNum(totalAPagar, 2, true);
        } else {
          const totalAPagar =
            parseToNum(it.monto_neto) + parseToNum(newtotalImpuesto);
          newTotal = parseToNum(totalAPagar, 2, true);
        }

        return {
          ...it,
          id_doc: newIdDoc,
          impuesto_tipo_calculo: impuesto_tipo_calculo,
          porcentaje_impuesto: newPorcentajeImpuesto,
          total: newTotal,
        };
      }

      return it;
    });

    setProjections(newList);
  };

  const handleSave = async () => {
    await Model.save({
      url: "reports/projections/items/new/flow/v2",
      dataForm: {
        id_ppto: pptoId,
        flows: projections,
      },
    });

    dispatch(iniUpdateBudget(detailBudget, pptoId));
    setOpen(false);
  };

  const handleQuitar = (id) => {
    const newList = projections.filter((it) => it.id !== id);
    setProjections(newList);
  };

  const handleDuplicar = (itemCopy) => {
    const item = itemCopy;

    const newList = [
      ...projections,
      {
        id: uuidv4(),
        referencia: item.referencia,
        porcentaje_flow: item.porcentaje_flow,
        monto_neto: item.monto_neto,
        id_item_ppto: item.id_item_ppto,
        total_item_ppto: item.total_item_ppto,
        fecha_proyeccion: item.fecha_proyeccion
          ? item.fecha_proyeccion
          : moment(new Date()).format("YYYY-MM-DD"),
        id_tarea: item.id_tarea,
        tipo_flujo: item.tipo_flujo,
        id_doc: item.id_doc,
        porcentaje_impuesto: item.porcentaje_impuesto,
        total: item.total,
        saved: false,
      },
    ];

    setProjections(newList);
  };

  const handleChangeSupplier = (e, newValue, item) => {
    const newList = projections.map((it) => {
      if (it.id === item.id) {
        return {
          ...it,
          id_contacto: newValue.id,
        };
      }

      return it;
    });

    setProjections(newList);
  };

  useEffect(() => {
    loadInitialValues();
  }, [loadInitialValues]);

  useEffect(() => {
    handleGetTasks();
  }, [handleGetTasks]);

  return (
    <Dialog
      className="dialogo-auto-nolimit"
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="simple-dialog-title"
    >
      <DialogTitle>
        Nueva proyección
        <IconButton
          className="p-dialog-icon-close"
          aria-label="close"
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className="DialogContentVistaPrevia">
        <h5 style={{ color: "gray", fontSize: "15px" }}>
          Nota: mostrando solo ítems con saldo por proyectar
        </h5>

        <table className="table p-table-global m-2">
          <thead className="p-thead-global">
            <tr className="text-center p-tr-titles-global">
              <th className="text-start">Tipo</th>
              <th className="text-start">Ítem</th>
              <th>%</th>
              <th>Monto neto</th>
              <th>Doc.</th>
              <th>Total</th>
              <th>Fecha</th>
              <th>Tarea</th>
              <th>Proveedor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {projections?.map((it) => (
              <tr className="p-tr-body-global" key={it.id}>
                <td
                  style={{
                    color: it.tipo_flujo === "ingreso" ? "green" : "red",
                    textTransform: "capitalize",
                  }}
                >
                  {it.tipo_flujo}
                </td>
                <td>
                  <div style={{ position: "relative" }}>
                    <span>
                      <input
                        className="p-1 uppercase"
                        type="text"
                        value={it.referencia}
                        onChange={(e) => handleChangeRef(e, it.id)}
                      />
                    </span>
                    <div
                      style={{
                        position: "absolute",
                        fontSize: "10px",
                        marginTop: "49px",
                        left: "-70px",
                        width: "300px",
                      }}
                    >
                      <label className="me-2">Inicial:</label>
                      <NumberFormat
                        style={{ fontSize: "12px" }}
                        displayType="text"
                        value={it?.total_item_ppto}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        decimalScale={2}
                        fixedDecimalScale={2}
                        prefix={`${simbolo} `}
                      />
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        fontSize: "10px",
                        marginTop: "49px",
                        left: "70px",
                        right: "0",
                        width: "400px",
                      }}
                    >
                      <label className="me-2">Saldo:</label>
                      <NumberFormat
                        style={{ fontSize: "12px" }}
                        displayType="text"
                        value={it?.saldo_por_proyectar || 0}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        decimalScale={2}
                        fixedDecimalScale={2}
                        prefix={`${simbolo} `}
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <NumberFormat
                    className="cantidades-item-line"
                    value={it?.porcentaje_flow || 0}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    suffix="%"
                    decimalScale={2}
                    fixedDecimalScale={2}
                    onValueChange={(values, sourceInfo) =>
                      handleChangePercent({ ...values, sourceInfo }, it)
                    }
                  />
                </td>
                <td>
                  <NumberFormat
                    className="cantidades-item-line text-end"
                    value={parseFloat(it.monto_neto)}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={`${simbolo} `}
                    onValueChange={(values, sourceInfo) =>
                      handleChangeMonto({ ...values, sourceInfo }, it)
                    }
                    decimalScale={2}
                    fixedDecimalScale={2}
                  />
                </td>
                <td>
                  <div className="d-flex">
                    <select
                      style={{
                        border: "1px solid lightgray",
                        padding: "2px",
                        backgroundColor: "white",
                        width: "180px",
                        borderRadius: "3px",
                        textAlign: "left",
                        textTransform: "uppercase",
                        fontSize: "12px",
                      }}
                      name="id_doc"
                      onChange={(e) => handleChangeDoc(e, it.id)}
                    >
                      <option key="" value="">
                        --seleccionar--
                      </option>
                      {listaTiposDocumentos?.map((hi) => (
                        <option
                          key={hi.id}
                          selected={hi.id === it?.id_doc ? "selected" : ""}
                          value={hi.id}
                        >
                          {hi.nombre}
                        </option>
                      ))}
                    </select>
                    <span className="ms-2">
                      <NumberFormat
                        style={{ fontSize: "13px" }}
                        displayType="text"
                        value={it.porcentaje_impuesto}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        suffix="%"
                      />
                    </span>
                  </div>
                </td>
                <td className="text-end">
                  <NumberFormat
                    style={{ fontSize: "13px" }}
                    displayType="text"
                    value={parseFloat(it.total)}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    decimalScale={2}
                    fixedDecimalScale={2}
                    prefix={`${simbolo} `}
                  />
                </td>
                <td className="text-center">
                  <input
                    style={{
                      padding: "2px",
                      borderRadius: "3px",
                      border: "1px solid lightgray",
                    }}
                    type="date"
                    value={it?.fecha_proyeccion}
                    onChange={(value) => handleChangeDate(value, it.id)}
                  />
                </td>
                <td>
                  <select
                    style={{
                      border: "1px solid lightgray",
                      padding: "2px",
                      backgroundColor: "white",
                      width: "180px",
                      borderRadius: "3px",
                      textAlign: "left",
                      textTransform: "uppercase",
                    }}
                    name="id_tarea"
                    onChange={(e) => handleChangeHito(e, it.id)}
                  >
                    <option key="" value="">
                      --seleccionar--
                    </option>
                    {tasksList?.map((hi) => (
                      <>
                        <option
                          key={hi.id}
                          selected={hi.id === it?.id_tarea ? "selected" : ""}
                          value={hi.id}
                          disabled
                        >
                          HITO: {hi.nombre}
                        </option>
                        {hi?.subs?.map((ta) => (
                          <>
                            <option
                              key={ta.id}
                              selected={
                                ta.id === it?.id_tarea ? "selected" : ""
                              }
                              value={ta.id + "|" + ta.fecha_fin}
                              className="p-2"
                            >
                              --TA: {ta.nombre}
                            </option>
                            {ta?.subs?.map((st) => (
                              <option
                                key={st.id}
                                selected={
                                  st.id === it?.id_tarea ? "selected" : ""
                                }
                                value={st.id + "|" + st.fecha_fin}
                                className="p-2"
                              >
                                ----ST: {st.nombre}
                              </option>
                            ))}
                          </>
                        ))}
                        <hr />
                      </>
                    ))}
                  </select>
                </td>
                <td>
                  {it.tipo_flujo === "egreso" ? (
                    <div
                      style={{ width: "200px" }}
                      className="p-text-autocomplete"
                    >
                      <Autocomplete
                        value={
                          listSuppliers?.find(
                            (it) =>
                              parseInt(it.id) === parseInt(it?.id_contacto),
                          ) || null
                        }
                        onChange={(e, newValue) =>
                          handleChangeSupplier(e, newValue, it)
                        }
                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);
                          return filtered;
                        }}
                        id="auto-complete"
                        autoComplete
                        includeInputInList
                        fullWidth
                        freeSolo
                        options={listSuppliers}
                        getOptionLabel={(option) => {
                          if (typeof option === "string") {
                            return option;
                          }

                          return option.nombre;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="--seleccionar--"
                            variant="standard"
                            style={{ textTransform: "capitalize" }}
                          />
                        )}
                      />
                    </div>
                  ) : (
                    "No aplica"
                  )}
                </td>
                <td>
                  <div className="d-flex">
                    <button
                      className="btn btn-link p-links-line"
                      type="button"
                      onClick={() => handleDuplicar(it)}
                    >
                      Duplicar
                    </button>
                    <button
                      className="btn btn-link p-links-line"
                      type="button"
                      onClick={() => handleQuitar(it.id)}
                    >
                      Quitar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="d-flex justify-content-end mt-2">
          <button
            style={{ width: "150px", margin: "10px" }}
            className="btn p-btn-primary"
            onClick={handleSave}
          >
            Guardar
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
